import { createContext } from 'react';

const MarketplaceContext = createContext<any>({})

export default MarketplaceContext